import { render } from "./VoteItemControl.vue?vue&type=template&id=f85ccdcc&scoped=true"
import script from "./VoteItemControl.vue?vue&type=script&lang=js"
export * from "./VoteItemControl.vue?vue&type=script&lang=js"

import "./VoteItemControl.vue?vue&type=style&index=0&id=f85ccdcc&scoped=true&lang=css"

import exportComponent from "C:\\Mobile\\mobile\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f85ccdcc"]])

export default __exports__